// extracted by mini-css-extract-plugin
module.exports = {"RedigerTjenesteSide":"RedigerTjenesteSide_RedigerTjenesteSide__uL7np","Wrapper":"RedigerTjenesteSide_Wrapper__377-Y"};